import { FC, useState, useEffect, useId } from 'react';
import clsx from 'clsx';

import { InputTextField, Text, Types } from '@marriott/mi-ui-library';
import { PhoneNumberFieldProps } from './PhoneNumberField.types';
import { StyledPhoneNumberField } from './PhoneNumberField.styles';

export const PhoneNumberField: FC<PhoneNumberFieldProps> = props => {
  const {
    label,
    inputErrorMsg,
    inputTimezoneError,
    clearTimezoneError,
    placeHolderText,
    disabled = false,
    isNonChinaMobileEnabled = false,
    isRegisteredNumber = false,
    dropdownTimeZoneOptions,
    defaultTimeZoneOption,
    fetchMobileNumber,
    inputValue,
  } = props;
  const countryTimeZones = dropdownTimeZoneOptions || [];
  const [countryTimeZone, setCountryTimeZone] = useState(defaultTimeZoneOption);
  const [mobileNumber, setMobileNumber] = useState(inputValue);
  const [selectedTimeZoneValue, setSelectedTimeZoneValue] = useState('');
  const inputId = useId();
  const errorMessage1 = 'Please limit your input to 16 characters.';
  const [customError, setCustomError] = useState({
    errorTripPhone: '',
  });
  useEffect(() => {
    setCountryTimeZone(defaultTimeZoneOption);
  }, [defaultTimeZoneOption]);

  const setCompleteMobileNumber = (cc: string, mobNum: string | undefined) => {
    fetchMobileNumber({
      countryTimeZone: cc,
      mobileNumber: mobNum,
    });
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleCountryTimeZoneChange = (option: any) => {
    setCountryTimeZone(option?.value);
    setCompleteMobileNumber(option?.value, mobileNumber);

    if (clearTimezoneError) {
      clearTimezoneError();
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isInputError, setIsInputError] = useState<boolean>(true);
  return (
    <StyledPhoneNumberField>
      <div className="d-flex">
        <div className="inputtext-field">
          <InputTextField
            label={'phone'}
            inputValue={mobileNumber}
            showErrorMessage={!isInputError}
            placeHolderText={placeHolderText}
            messageToShow={customError.errorTripPhone || inputErrorMsg}
            setErrorHtml={true}
            messageClass="error-label"
            inputMaxLength={16}
            infoLabel={`${label}-number`}
            getInputProps={() => ({
              autoComplete: 'off',
              id: `${inputId}-Dialcode`,
              disabled: disabled || isRegisteredNumber,
            })}
            getLabelProps={() => ({
              htmlFor: `dropdown-label-fp-country`,
            })}
            className={clsx(
              'm-input-field m-phoneNum mb-3',
              disabled || isRegisteredNumber ? 'is-disabled' : '',
              inputErrorMsg ? 'is-error' : ''
            )}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getInputValue={(val: any) => {
              setMobileNumber(val);
              setCompleteMobileNumber(countryTimeZone, val);
              if (val.length >= 16) {
                setCustomError({ ...customError, errorTripPhone: errorMessage1 });
                setIsInputError(false);
              } else {
                setCustomError({ ...customError, errorTripPhone: '' });
                setIsInputError(true);
              }
            }}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onBlur={(val: any) => {
              const newValue = val.target.value;
              setMobileNumber(val.target.value);
              if (newValue.length >= 16) {
                setCustomError({ ...customError, errorTripPhone: errorMessage1 });
              } else {
                setCustomError({ ...customError, errorTripPhone: '' });
              }
            }}
          />
          {inputErrorMsg && (
            <div className="error-container ">
              <span className="error-icon">
                <i className="icon-alert"></i>
              </span>
              <Text
                element={Types.tags.paragraph}
                fontSize={Types.size.extraSmall}
                customClass={`error-message time`}
                dangerouslySetInnerHTML={{ __html: inputErrorMsg }}
              ></Text>
            </div>
          )}
        </div>
        <div className="dropdown-field ml-2">
          <div className="m-form-group custom-select-wrapper">
            <select
              name="selectCountryTimeZone"
              id="selectCountryTimeZone"
              value={selectedTimeZoneValue}
              onChange={e => {
                setSelectedTimeZoneValue(e.target.value);
                handleCountryTimeZoneChange(e.target);
              }}
              className={`m-dropdown-field ${inputTimezoneError ? 'is-error' : ''}`}
              required
            >
              <option
                value={countryTimeZone === 'Select' ? '' : countryTimeZone}
                hidden={countryTimeZone === 'Select' ? true : false}
                disabled={countryTimeZone === 'Select' ? true : false}
              >
                {countryTimeZone}
              </option>
              {countryTimeZones
                .filter(option => option.value !== countryTimeZone)
                .map((option, index) => (
                  <option key={index} value={option.value} role="option">
                    {option.label}
                  </option>
                ))}
            </select>
          </div>
          {disabled || !isNonChinaMobileEnabled ? <div className="blurred"></div> : ''}
          {inputTimezoneError && (
            <div className="error-container error-position ">
              <span className="error-icon">
                <i className="icon-alert"></i>
              </span>
              <Text
                element={Types.tags.paragraph}
                fontSize={Types.size.extraSmall}
                customClass={`error-message time`}
                dangerouslySetInnerHTML={{ __html: inputTimezoneError }}
              ></Text>
            </div>
          )}
        </div>
      </div>
    </StyledPhoneNumberField>
  );
};
